import moment from "moment";
import { QUICK_FILTER_PAGE_IDS } from "../quickFilterUtils";
import { createSystemPresetsFromRules } from "./createSystemPresetsFromRules";

const PAGE_ID = QUICK_FILTER_PAGE_IDS.TARGETING_V2;

const AMAZON_RULES = [
  {
    section: "metrics",
    id: "spend_gt_0",
    name: "Spend > 0",
    member: "spends",
    operator: "gt",
    values: [0],
  },
  {
    section: "dimension",
    id: "campaign_status_enabled",
    name: "Campaign Status = Enabled",
    member: "campaign_status",
    operator: "equals",
    values: ["ENABLED"],
  },
  {
    section: "dimension",
    id: "bid_strategy_down",
    name: "Bid Strategy = Down",
    member: "campaign_bid_strategy",
    operator: "equals",
    values: ["Down"],
  },
  {
    section: "dimension",
    id: "targeting_type_automatic",
    name: "Targeting Type = Automatic",
    member: "targeting_type",
    operator: "equals",
    values: ["Automatic"],
  },
  {
    section: "metrics",
    id: "current_bid_gt_30",
    name: "Current Bid > 30",
    member: "bid",
    operator: "gt",
    values: [30],
  },
  {
    section: "dimension",
    id: "targeting_added_on_last_7_days",
    name: "Targeting Added On (Last 7 Days)",
    member: "amz_creation_date_time",
    operator: "afterOrOnDate",
    // Dynamic: today - 7 (e.g. 27 Aug → 20 Aug)
    values: () => [moment().subtract(7, "days").format("YYYY-MM-DD")],
  },
];

/** Factory so relative-date presets resolve on each read/apply. */
const TARGETING_V2_PRESETS = {
  amazon: () => createSystemPresetsFromRules(PAGE_ID, "amazon", AMAZON_RULES),
};

export default TARGETING_V2_PRESETS;
